import { render, staticRenderFns } from "./StockInfo.vue?vue&type=template&id=b66a09be&scoped=true"
import script from "./StockInfo.vue?vue&type=script&lang=js"
export * from "./StockInfo.vue?vue&type=script&lang=js"
import style0 from "./StockInfo.vue?vue&type=style&index=0&id=b66a09be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66a09be",
  null
  
)

export default component.exports